import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonUtilsService } from '../../services/commonutils/common-utils.service';
import { Store } from '@ngrx/store';
import { getCustomEntityRecordChangeLogs$ } from '../../store/selectors/custom.selector';
import { RecordChangeLog, RecordUserChangeLog } from '../../interface/record-change-log.interface';
import { filter, Subject, takeUntil } from 'rxjs';

import { AppsState } from '../../store/states';

@Component({
    selector: 'app-audit-change-logs-dialog',
    templateUrl: './audit-change-logs-dialog.component.html',
    styleUrls: ['./audit-change-logs-dialog.component.scss'],
    standalone: false,
})
export class AuditChangeLogsDialogComponent implements OnInit, OnDestroy {
    private unSubscribe = new Subject<void>();
    public changeLogs: any;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<AuditChangeLogsDialogComponent>,
        private store$: Store<AppsState>
    ) {}

    public closeModal = () => {
        this.dialogRef.close();
    };

    public trackByFn(_index: number, item: any): any {
        return item;
    }

    ngOnInit(): void {
        this.store$
            .select(getCustomEntityRecordChangeLogs$)
            .pipe(
                takeUntil(this.unSubscribe),
                filter(result => result !== undefined)
            )
            .subscribe(result => {
                const records = result[this.data?.recordId] || [];
                this.changeLogs = [];
                const logs: RecordChangeLog[] = [];
                records.forEach((record: any) => {
                    const logIndex = logs.findIndex(logRecord => logRecord.modifiedDate === record.modifiedDate);
                    let log: RecordChangeLog;
                    if (logIndex === -1) {
                        log = {
                            modifiedDate: record.modifiedDate,
                            users: [],
                        };
                        logs.push(log);
                    } else {
                        log = logs[logIndex];
                    }
                    const userIndex = log.users.findIndex(userRecord => userRecord.userName === record.userName);
                    let user: RecordUserChangeLog;
                    if (userIndex === -1) {
                        user = {
                            userName: record.userName,
                            logs: [],
                        };
                        log.users.push(user);
                    } else {
                        user = log.users[userIndex];
                    }
                    user.logs.push(record);
                });
                this.changeLogs = CommonUtilsService.cloneObject(logs);
            });
    }

    ngOnDestroy(): void {
        this.unSubscribe.next();
        this.unSubscribe.complete();
    }
}
